export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const ADD_NEW_PAYMENT = '/home/money_items/new'
export const EDIT_PAYMENT = '/home/money_items/:id'
export const DUPLICATE_PAYMENT = '/home/money_items/duplicate/:id'